import React, { Component } from 'react';
import * as mat from 'material-ui';
import { connect } from 'react-redux';
import dummy from '../images/Logo.jpg'
import FaPlayCircle from 'react-icons/lib/fa/play-circle'
import FaUser from 'react-icons/lib/fa/user'
import MdFavorite from 'react-icons/lib/md/favorite';
import MdInfo from 'react-icons/lib/md/info'
import { DetailsQuiz, FavoriteQuizAction, UnFavoriteQuizAction, } from '../../action/detailAction';
import { PlayOptionsAction } from '../../action/playAction';


class MyHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            notStarted: false,
            expired: false,
            dataEmptyList: false
        }
        this.handleCloseexpired = this.handleCloseexpired.bind(this)
        this.handleClosenotStarted = this.handleClosenotStarted.bind(this)

    }

    Details(keys) {
        this.props.DetailsQuiz(keys);
    }
    FavoriteQuiz(keys) {
        let action = {
            nodeKey: keys,
            userUid: this.props.auth.uid
        }
        this.props.FavoriteQuizAction(action, this.props.AllData);
    }
    UnFavoriteQuiz(keys) {
        let action = {
            nodeKey: keys,
            userUid: this.props.auth.uid
        }
        this.props.UnFavoriteQuizAction(action, this.props.AllData)
    }
    PalyOption(keys, quizObj) {
        console.log(keys, "ISME KYA ARAHA ?", quizObj)

        if (Date.now() > quizObj.currentLicense.licenseStartDate && Date.now() < quizObj.currentLicense.licenseEndDate) {
            console.log('valid license');
            this.props.PlayOptionsAction(keys)
        }
        else {
            console.log('insi8de else', quizObj, Date.now(), quizObj.currentLicense.licenseStartDate);
            if (Date.now() < quizObj.currentLicense.licenseStartDate) {
                console.log('Your license period has not started yet.');
                this.setState({ notStarted: true })

            }
            else if (Date.now() > quizObj.currentLicense.licenseEndDate) {
                console.log('Your license period has expired. Contact admin to renew license.')
                this.setState({ expired: true })

            }
        }

    }

    handleClosenotStarted() {
        this.setState({ notStarted: false })
    }
    handleCloseexpired() {
        this.setState({ expired: false })
    }

    render() {

        const actions = [
            <mat.FlatButton
                labelStyle={{ color: "#2295f3" }}
                label="Cancel"
                primary={true}
                onClick={this.handleClosenotStarted}
            />

        ];
        const actionsexpired = [
            <mat.FlatButton
                labelStyle={{ color: "#2295f3" }}
                label="Cancel"
                primary={true}
                onClick={this.handleCloseexpired}
            />

        ];
        const {
            AllData,
            FavData,
            success,
            successFlag,
            errorMessage,
            errorFlag,
        } = this.props;
        let FavList;
        let listedData;
        if (!listedData) {
            listedData = Object.keys(AllData).map((key, index) => {
                let val = AllData[key];
                let keys = key;
                return (
                    <mat.Card key={index} zDepth={1} style={{ marginTop: '2%', overflow: 'hidden' }}>
                        <mat.CardHeader
                            title={val.titles}
                            subtitle={<span>{val.description}</span>}
                            subtitleStyle={{ color: 'gray' }}
                            actAsExpander={true}
                            showExpandableButton={true}
                            titleStyle={{ fontSize: '2em' }}
                            avatar={<mat.Avatar
                                src={val.imgUrl === 'https' ? val.imgUrl = dummy : val.imgUrl}
                                size={70}
                            />}

                        />
                        <mat.CardText expandable={true}>
                            <mat.CardActions style={{ marginLeft: '5%' }}>
                                <mat.FlatButton
                                    onClick={this.PalyOption.bind(this, keys, AllData[key])}
                                    label='Play'
                                    labelStyle={{ color: '#000000' }}
                                    icon={<FaPlayCircle style={{ fontSize: 22, color: '#2196f3' }} />}
                                />
                                <mat.Dialog
                                    title="Your license period has not started yet."
                                    actions={actions}
                                    modal={false}
                                    open={this.state.notStarted}
                                    onRequestClose={this.handleClosenotStarted}>

                                </mat.Dialog>
                                <mat.Dialog
                                    title="Your license period has expired. Contact admin to renew license."
                                    actions={actionsexpired}
                                    modal={false}
                                    open={this.state.expired}
                                    onRequestClose={this.handleCloseexpired}>

                                </mat.Dialog>
                                <mat.FlatButton
                                    onClick={this.Details.bind(this, keys)}
                                    label='Detail'
                                    labelStyle={{ color: '#000000' }}
                                    icon={<MdInfo style={{ fontSize: 22, color: '#000000' }} />}
                                />
                                <mat.FlatButton
                                    onClick={this.FavoriteQuiz.bind(this, keys)}
                                    label='Favourite'
                                    labelStyle={{ color: '#000000' }}
                                    icon={<MdFavorite style={{ fontSize: 22, color: '#b80000' }} />}
                                />
                            </mat.CardActions>
                        </mat.CardText>
                    </mat.Card>
                )
            }
            )
        }
        if (!FavList) {
            FavList = Object.keys(FavData).map((key, index) => {
                let val = FavData[key];
                let keys = key;
                return (
                    <mat.Card key={index} zDepth={1} style={{ marginTop: '2%', overflow: 'hidden' }}>
                        <mat.CardHeader
                            title={val.titles}
                            subtitle={<span>{val.description}</span>}
                            subtitleStyle={{ color: 'gray' }}
                            actAsExpander={true}
                            showExpandableButton={true}
                            titleStyle={{ fontSize: '2em' }}
                            avatar={<mat.Avatar
                                src={val.imgUrl === 'https' ? val.imgUrl = dummy : val.imgUrl}
                                size={70}
                            />}

                        />
                        <mat.CardText expandable={true}>
                            <mat.CardActions style={{ marginLeft: '5%' }}>
                                <mat.FlatButton
                                    onClick={this.UnFavoriteQuiz.bind(this, keys)}
                                    label='Unfavorite'
                                    labelStyle={{ color: '#000000' }}
                                    icon={<MdFavorite style={{ fontSize: 22, color: '#fbc02d' }} />}
                                />
                            </mat.CardActions>
                        </mat.CardText>
                    </mat.Card>
                )
            }
            )
        }
        setTimeout(() => {
            if (listedData.length === 0 || FavList.length === 0) {
                this.setState({
                    dataEmptyList: true
                })
            } else {
                this.setState({
                    dataEmptyList: false
                })
            }
        }, 3000)

        return (
            <div>
                <div className='col-md-8 col-md-offset-2 col-xs-10 col-xs-offset-1 home'>

                    <mat.Card zDepth={0}>
                        <mat.Tabs>
                            <mat.Tab style={{ backgroundColor: '#d9e3f0', color: 'black' }} label={
                                <span>
                                    <FaUser style={{ color: 'black', fontSize: 17, marginTop: -3 }} />&nbsp; Shared with me
                                    </span>
                            }
                            >
                                {(listedData.length === 0) ? (
                                    <div>
                                        {(this.state.dataEmptyList === true) ? (
                                            <div className="col-md-10 col-md-offset-1 text-center" style={{ marginTop: '10%' }}>
                                                <p ><strong>There is no record</strong>...</p>
                                            </div>
                                        ) : (
                                                <div className="col-md-10 col-md-offset-1 text-center" style={{ marginTop: '10%' }}>
                                                    <mat.CircularProgress thickness={6} size={50} color={'#4aa6ef'} />
                                                    <br />
                                                    <p ><strong>Loading</strong>...</p>
                                                </div>
                                            )
                                        }
                                    </div>
                                ) : (
                                        <div>
                                            {listedData}
                                        </div>
                                    )}
                            </mat.Tab>
                            <mat.Tab
                                style={{ backgroundColor: '#d9e3f0', color: 'black' }}
                                label={
                                    <span>
                                        <MdFavorite style={{ color: 'red', fontSize: 17, marginTop: -3 }} />&nbsp; Favourite
                                    </span>
                                }
                            >
                                {(FavList.length === 0) ? (
                                    <div>
                                        {(this.state.dataEmptyList === true) ? (
                                            <div className="col-md-10 col-md-offset-1 text-center" style={{ marginTop: '10%' }}>
                                                <p ><strong>There is no record</strong>...</p>
                                            </div>
                                        ) : (
                                                <div className="col-md-10 col-md-offset-1 text-center" style={{ marginTop: '10%' }}>
                                                    <mat.CircularProgress thickness={6} size={50} color={'#4aa6ef'} />
                                                    <br />
                                                    <p ><strong>Loading</strong>...</p>
                                                </div>
                                            )
                                        }
                                    </div>
                                ) : (
                                        <div>
                                            {FavList}
                                        </div>
                                    )}
                            </mat.Tab>
                        </mat.Tabs>
                    </mat.Card>
                </div>
                <mat.Snackbar
                    open={successFlag}
                    message={success}
                    contentStyle={{ color: '#ffffff' }}
                    autoHideDuration={4000}
                    bodyStyle={{ backgroundColor: '#68bc00' }}
                // onRequestClose={this.handleRequestClose}
                />
                <mat.Snackbar
                    open={errorFlag}
                    message={errorMessage}
                    autoHideDuration={4000}
                    contentStyle={{ color: '#ffffff' }}
                    bodyStyle={{ backgroundColor: '#d33115' }}
                // onRequestClose={this.handleRequestClose}
                />
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        auth: state.authReducers.userDetails,
        AllData: state.authReducers.SharedData,
        success: state.DetailReducers.FavorSuccess,
        successFlag: state.DetailReducers.FavorFlag,
        errorMessage: state.DetailReducers.FavorError,
        errorFlag: state.DetailReducers.FavorErrorFlag,
        FavData: state.DetailReducers.FavoriteQuizData,
        // dataEmpty: state.authReducers.dataEmpty
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        DetailsQuiz: (action) => {
            dispatch(DetailsQuiz(action));
        },
        FavoriteQuizAction: (action, Allquiz) => {
            dispatch(FavoriteQuizAction(action, Allquiz))
        },
        UnFavoriteQuizAction: (action, Allquiz) => {
            dispatch(UnFavoriteQuizAction(action, Allquiz))
        },
        PlayOptionsAction: (action, checkLicense) => {
            dispatch(PlayOptionsAction(action, checkLicense))
        }

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MyHome);
// export default MyHome;


// WEBPACK FOOTER //
// ./src/component/home/home.jsx